module.exports = __webpack_public_path__ + "static/img/fr-17.e7c481a6.png";